var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{attrs:{"id":"app"}},[_c('iframe',{attrs:{"src":_vm.src,"id":"custom-iframe","frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }